/* --------------------------------
[JSファイルの説明]
・gulpで scripts.json の libs の各ファイルを連結し、 /js/libs.js に書き出している
・gulpで scripts.json の scripts の各ファイルを連結＆圧縮し、 /js/scripts.js に書き出している
・HTMLでは上記の libs.js と scripts.js を読み込んでいる
・もしもgulpの環境が無くて更新が困難な場合は、書き出したJSは無視して scripts.json の各ファイルをHTMLで直接読み込んでも動作は可能
-------------------------------- */

//aタグ スムーススクロール
$(function(){
  $('a[href^="#"]').click(function(){
    var speed = 500;
    var href= $(this).attr("href");
    var target = $(href == "#" || href == "" ? 'html' : href);
    var position = target.offset().top;
    $("html, body").animate({scrollTop:position}, speed, "swing");
    return false;
  });
});

$(function () {
    // 別ページの場合は以下
  var urlHash = location.hash;
  if (urlHash) {
    $('body,html').stop().scrollTop(0);
    setTimeout(function(){
      // ヘッダー固定の場合はヘッダーの高さを数値で入れる、固定でない場合は0
      var headerHight = 0;
      var target = $(urlHash);
      var position = target.offset().top - headerHight;

      if($(window).innerWidth() >= 768) {
//        position -= $('.l-header').innerHeight();
      }

      position -= 50;

      $('body,html').stop().animate({scrollTop:position}, 600);
    }, 400);
  }
});

$(function() {
  $('.home-loading').each(function(index, el) {
    const loading = $(this);
    const kv = $('.home-kv');
    const header = $('.l-header');

    header.addClass('is-homeAni');

    setTimeout(function(){
      loading.addClass('is-ani');
    }, 400);

    setTimeout(function(){
      loading.addClass('is-hide');
      kv.addClass('is-ani');
      header.removeClass('is-homeAni');

      setTimeout(function(){
        kv.addClass('is-cathAni');

        runLogoAni();
      }, 1400);
    }, 1200);

    function runLogoAni() {
      setInterval(function(){
        kv.removeClass('is-cathAni');

        setTimeout(function(){
          kv.addClass('is-cathAni');
        }, 100);
      }, 6000);
    }
  });
});

$(function(){
  $('.home-kv__slick').each(function(index, el) {
    const $slider = $(this);

    setTimeout(function(){
      $slider.slick({
        autoplay: true,
        autoplaySpeed: 4000,
        fade: true,
        speed: 2000,
        pauseOnFocus: false,
        pauseOnHover: false,
        pauseOnDotsHover: false,
        arrows: false
      })
      .on({
        beforeChange: function(event, slick, currentSlide, nextSlide) {
          $(".slick-slide", this).eq(currentSlide).addClass("preve-slide");
          $(".slick-slide", this).eq(nextSlide).addClass("slide-animation");
        },
        afterChange: function() {
          $(".preve-slide", this).removeClass("preve-slide slide-animation");
        }
      });

      $slider.find(".slick-slide").eq(0).addClass("slide-animation");

    }, 1000);
  });
});

//fade
$(function(){
  var fade = $('.fade, .fade-ani');

  fade.each(function(index, el) {
    var t = $(this);

    setTimeout(function(){
      $(window).on('resize scroll', function(event) {
        run();
      });

      run();
    }, 200);

    function run() {
      var winT = $(window).scrollTop();
      var winH = $(window).innerHeight();
      var winB = winT + winH;
      var tT = t.offset().top;
      var tH = t.innerHeight();
      var tB = tT + tH;

      var pointH = tT + 100;
      var pointSc = winB;
      var pointD = 0;

      var h = t.attr('data-fade-h');
      if(h) {
        pointH = tT + tH * h / 100;
      }

      var sc = t.attr('data-fade-sc');
      if(sc) {
        pointSc = winT + winH * sc / 100;
      }

      var d = t.attr('data-fade-delay');
      if(d) {
        pointD = d;
      }

      if(pointH < pointSc) {
        setTimeout(function(){
          t.addClass('is-fade');
          next();
        }, pointD);
      }
    }

    function next() {
      var nextStr = t.attr('data-fade-next-target');
      if(nextStr) {
        var nextArr = nextStr.split(' ');
        if(nextArr) {
          for (var i = 0; i < nextArr.length; i++) {
            var next = nextArr[i];
            var nextTar = $('[data-fade-next-id="' + next + '"]');
            if(nextTar[0]) {
              var nextDelay = t.attr('data-fade-next-delay');
              var delay = 0;
              if(nextDelay) {
                delay = parseInt(nextDelay);
              }

              var nextStep = t.attr('data-fade-next-step');
              var step = 0;
              if(nextDelay) {
                step = delay;
              }
              if(nextStep) {
                step = parseInt(nextStep);
              }

              nextTar.each(function(index, el) {
                var t2 = $(this);
                var step2 = step * index + delay;

                setTimeout(function(){
                  t2.addClass('is-fade-next');
                  t2.attr('data-test', step2);
                }, step2);
              });
            }
          }
        }
      }
    }
  });
});

$(function() {
  $('.p-intPosts__slick').each(function(index, el) {
    const $slider = $(this);

    $slider.slick({
      dots: false,
      variableWidth: true,
      centerMode: true,
      arrows: false,
      autoplay: true,
      autoplaySpeed: 1400,
      speed: 1000,
      cssEase: "ease",
      swipe: true,
      pauseOnFocus: false,
      pauseOnHover: true,
      waitForAnimate: false
    });

  });
});

$(function(){
  $('.p-hd__menu a').each(function(index, el) {
    const $menu = $(this);
    const $nav = $('.p-hd__navSP');
    const $close = $('.p-hd__menu2');

    $menu.on('click', function(event) {
      runOpen();
    });

    $close.on('click', function(event) {
      runClose();
    });

    function runOpen() {
      $nav.addClass('is-show');
    }

    function runClose() {
      $nav.removeClass('is-show');
    }
  });
});


$(function(){
  $('.p-hd__navSP').each(function(index, el) {
    const $root = $(this);
    const $parent = $('.p-hd__navSP ul li a.-parent');

    $parent.on('click', function(event) {
      const $t = $(this);
      const $child = $t.next('ul.-child');

      $t.toggleClass('is-on');
      $child.stop().slideToggle();
    });
  });
});
